import React from "react";
import { Box, Button } from '@mui/material';
import { logoutFunc } from "../utils/useCookies";
import LogoSrc from "../assets/images/logo.png";
import {loggedIn} from "../store/gloabalState";
import {useRecoilState, useRecoilValue} from "recoil";


export default function Header() {
    const [isLoggedIn, setIsLoggedIn] = useRecoilState(loggedIn);
    const logout = () => {
        logoutFunc(setIsLoggedIn);
        window.location.href = window.location.origin;
    }

    return (
        <Box className="navheader d-flex align-items-center">
            <div className="logowrap">
                <img src={LogoSrc} alt="logo" />
            </div>
            {
                isLoggedIn &&
                <Button variant="outlined" className="ms-auto" onClick={logout}>Logout</Button>
            }
        </Box>
    )
}